import React from "react";
import HeroSection from "../components/GetInvolved/HeroSection";
import AboutSection from "../components/GetInvolved/AboutSection";
import CarouselSection from "../components/GetInvolved/CarouselSection";
import JoinUsSection from "../components/GetInvolved/JoinUsSection";

const GetInvolved = () => {
  return (
    <div>
      <HeroSection />
      <AboutSection />
      <CarouselSection />
      <JoinUsSection />
    </div>
  );
};

export default GetInvolved;
